// @generated by protoc-gen-grpc-gateway-es v0.3.1 with parameter "target=ts,generate_name_parser=true"
// @generated from file ai/h2o/mlops/deployer/v2/log_service.proto (package ai.h2o.mlops.deployer.v2, syntax proto3)
/* eslint-disable */

import { RPC } from "../../../../../runtime";

/**
 * The request message for generate logs.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.GenerateLogsRequest
 */
export type GenerateLogsRequest = {
/**
 * Required. The resource name of the deployments for which logs will be generated.
 * Format: `workspaces/{workspace}/deployments/{deployment}`
 *
 * @generated from field: string name = 1;
 */
name: string;
/**
 * (-- api-linter: core::0140::prepositions=disabled
 *     aip.dev/not-precedent: We need to do this because this name is the same in K8 logs API. --)
 * Timestamp indicating time from logs should be retrieved.
 *
 * @generated from field: google.protobuf.Timestamp since_time = 2;
 */
sinceTime?: string | null;
}
;
/**
 * Response message containing access information for the generated log archive.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.GenerateLogsResponse
 */
export type GenerateLogsResponse = {
/**
 * The artifact id to the generated zip file containing logs.
 *
 * @generated from field: string artifact_id = 1;
 */
artifactId?: string;
/**
 * Timestamp until which identical requests will return this same file.
 * Repeated requests before this time will not trigger new log generation.
 *
 * @generated from field: google.protobuf.Timestamp cached_until_time = 2;
 */
cachedUntilTime?: string;
/**
 * Timestamp indicating when the log archive will expire.
 * The zip file will be automatically deleted after this time.
 *
 * @generated from field: google.protobuf.Timestamp valid_until_time = 3;
 */
validUntilTime?: string;
}
;
/**
 * Generates and exports logs from pods associated with the deployment.
 * Retrieved logs are compressed into a zip archive and stored in cloud storage.
 * The operation uses the deployment name to identify target pods.
 * The response provides access information for the generated logs.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.LogService.GenerateLogs
 */
export const LogService_GenerateLogs = new RPC<GenerateLogsRequest,GenerateLogsResponse>("POST", "/v2/{name=workspaces/*/deployments/*}:generateLogs");
